import create from 'zustand'
import {SearchGame} from '../search-results/helper'

interface SearchStore {
  searchQuery: string
  searchResults: SearchGame[]
  allGames: SearchGame[]
  isFocused: boolean
  setSearchQuery: (query: string) => void
  setSearchResults: (results: SearchGame[]) => void
  setAllGames: (games: SearchGame[]) => void
  clearSearch: () => void
  setFocused: (focused: boolean) => void
}

const useSearchStore = create<SearchStore>((set) => ({
  searchQuery: '',
  searchResults: [],
  allGames: [],
  isFocused: false,
  setSearchQuery: (query: string) => set({searchQuery: query}),
  setSearchResults: (results: SearchGame[]) => set({searchResults: results}),
  setAllGames: (games: SearchGame[]) => set({allGames: games}),
  clearSearch: () => set({searchQuery: '', searchResults: []}),
  setFocused: (focused: boolean) => set({isFocused: focused}),
}))

export default useSearchStore
